import React from 'react';
import { ACCENT_COLOR } from './colors';

const Edit = ({
  width = 18,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M1 16H17" stroke="#333333" strokeWidth="2" />
    <path d="M6 14H3V11L13 1L16 4L6 14Z" fill={ACCENT_COLOR} />
  </svg>
);

export default Edit;
